/* globals elkitorg_config */

import { node_observable_component } from 'common/util/ComponentDecorator';
import LinkUtil from "common/util/LinkUtil";

@node_observable_component
export default class cartCoupon {
	static classname = 'cart-coupon';

	constructor($cartCoupon) {
		this.$cartCoupon = $cartCoupon;
		this.bindEvents();
	}

	bindEvents = () => {
		const $btn = this.$cartCoupon.find('.cart-coupon__btn');
		const $cartCouponInput = this.$cartCoupon.find('.cart-coupon__input');
		const $couponCode = this.$cartCoupon.find('.cart-coupon__code');
		const $hasCoupon = this.$cartCoupon.find('.cart-coupon__has-coupon');
		$btn.on('click', () => {
			const url = LinkUtil.create( elkitorg_config.cart_url || '').toString();
			const data = {
				coupon_code: $cartCouponInput.val()
			};
			if ($btn.hasClass('cart-coupon__delete-coupon')) {
				data.coupon_code = '';
				$cartCouponInput.slideToggle();
				$couponCode.slideToggle();
				$hasCoupon.slideToggle();
			} else {
				$cartCouponInput.slideToggle();
				$couponCode.slideToggle();
				$hasCoupon.slideToggle();
			}
			$.ajax({
				url: url,
				method: "post",
				data: data
			}).done((response) => {
				const $new_summary_container = $(response).find('.cart-summary');
				$('.cart-summary').replaceWith($new_summary_container);
			}).fail(function() {
				alert( "error" );
			}).always(function() {
			});

		});
	}
}
